import axios from "axios";
const baseUrl = "";
// const baseUrl = "https://edcweb-test.medon.com.cn";// 本地
const service = axios.create({
  baseURL: baseUrl,
  timeout: 50000,
});
service.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => Promise.reject(error)
);
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (response.status !== 200) {
      return Promise.reject(new Error(res.message || "Error"));
    } else {
      return res;
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);
export default service;
